import { render } from "./TileSelectionOption.vue?vue&type=template&id=9a973d64"
import script from "./TileSelectionOption.vue?vue&type=script&lang=js"
export * from "./TileSelectionOption.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__